/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { Button, Form, Input, Steps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import * as ACTIONS from '../../../redux/actions';
import regex from '../../../constants/system.keys';
import InputTag from '../../../components/InputTag';
import LocationSearchLocationIQ from '../../../components/LocationSearchLocationIQ';

import './index.scss'

const { Step } = Steps;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const MilestoneCameraAddComponent = ({
  onDone,
  gatewaySerial,
  gatewayAddress,
}) => {
  const {
    updateDevice,
    namespace,
    checkExternalDevice,
    addExternalDevice,
    dataUser,
    lastVisited,
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [isBlock, setIsBlock] = useState(false);
  const [requestId, setRequestId] = useState();
  const [handleScan, setHandleScan] = useState({
    loading: false,
    step: 0,
    data: null,
  });
  const [address, setAddress] = useState({
    note: '',
    lat: '',
    lng: '',
  });
  const [handleTimer, setHandleTimer] = useState();
  const { t } = useTranslation();
  const refHandleTimer = useRef();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [stepsEnabledStart, setStepsEnabledStart] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);

  useEffect(() => {
    if (dataUser) {
      if (!lastVisited && localStorage.getItem('tutorial') === '1') {
        setTimeout(() => {
          setStepsEnabledStart(true)
          setStepsEnabled(true)
        }, 300);
      }
    }
  }, [dataUser, lastVisited]);


  useEffect(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    setRequestId(new Date().getTime());
    return () => {
      setIsBlock(false);
      setHandleScan({
        loading: false,
        step: 0,
        data: null,
      });
      setAddress({ note: '', lat: '', lng: '' });
      setRequestId(null);
    };
  }, []);

  // useEffect(() => {
  //   if (source.current) {
  //     setTimeout(() => { source.current.input.focus() }, 1)
  //   }
  // }, [source]);

  useEffect(() => {
    if (!addExternalDevice) return
    console.log('🚀 ~ MilestoneCameraAddComponent ~ addExternalDevice:', addExternalDevice)
    if (addExternalDevice?.serial === handleScan.data?.serial) {
      setHandleScan(prev => ({
        ...prev,
        loading: false,
        step: 2,
      }))
      setTimeout(() => {
        setStepsEnabled(true)
      }, 300);
      dispatch(ACTIONS.addExternalDeviceReturn(null))
    }
  }, [addExternalDevice, handleScan]);
  useEffect(() => {
    console.log('🚀 ~ MilestoneCameraAddComponent ~ updateDevice:', updateDevice)
    if (!updateDevice) return
    if (updateDevice?.requestId !== requestId) return
    if (updateDevice?.isSuccess && updateDevice?.serial === handleScan.data?.serial) {
      dispatch(ACTIONS.updateDeviceReturn(null))
      return onDone();
    } else {
      form.setFields([
        {
          name: 'tags',
          errors: [t('Some thing went wrong')],
        },
      ])
    }
  }, [updateDevice, handleScan, requestId]);

  useEffect(() => {
    if (handleTimer === 0 && handleScan.loading) {
      setHandleScan((state) => ({ ...state, loading: false }));
      clearInterval(refHandleTimer.current);
      const fieldName = handleScan.step === 0 ? 'password' : handleScan.step === 1 ? 'name' : 'tags'
      form.setFields([
        {
          name: fieldName,
          errors: [t('Timeout, something went wrong!')],
        },
      ]);
    }
  }, [form, handleTimer, t, handleScan]);

  useEffect(() => {
    if (gatewayAddress) {
      form.setFieldsValue({
        location: gatewayAddress?.note ?? '',
      });
      setAddress(gatewayAddress);
    }
  }, [form, gatewayAddress]);

  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };

  const handleBack = () => {
    form.resetFields();
    setHandleScan({
      step: 0,
      loading: false,
      data: null,
    });
  };

  const handleSelect = (address) => {
    form.setFieldsValue({
      location: address?.note ?? '',
    });
    setAddress(address);
  };

  const handleAddDevice = useCallback(
    (factorySerial, name, requestId) => {
      if (factorySerial && factorySerial.length > 0 && name && handleScan.data?.serial && handleScan.data?.source) {
        console.log('🚀 ~ MilestoneCameraAddComponent ~ handleScan:', handleScan)
        let data = {
          namespace,
          serial: handleScan?.data?.serial,
          deviceType: 'camera',
          extraInfo: {
            typeCamera: 'milestone',
            name: name.trim(),
            factorySerial: factorySerial,
            gatewaySerial,
            source: handleScan.data?.source,
            username: handleScan.data.username,
            password: handleScan.data.password,
          },
          factorySerial,
        };
        console.log('🚀 ~ MilestoneCameraAddComponent ~ data:', data)
        let dataObj = {
          appServiceType: SERVICE.REQUEST_ADD_EXTERNAL_DEVICE,
          requestId,
          body: JSON.stringify(data),
        };
        console.log('🚀 ~ MilestoneCameraAddComponent ~ dataObj:', dataObj)
        return dispatch(ACTIONS.socketEmitEvent(dataObj));
      }
    },
    [namespace, gatewaySerial, handleScan]
  );

  const handleUpdateDevice = useCallback(
    (values, requestId) => {
      const { tags } = values;
      const { note, lat, lng } = address;
      if (handleScan.data?.serial) {
        let data = {
          note: note ?? "",
          lat: lat ?? 0,
          lng: lng ?? 0,
          serial: handleScan.data?.serial,
          namespace,
          tags,
        };
        let dataObj = {
          appServiceType: SERVICE.UPDATE_DEVICE,
          requestId,
          body: JSON.stringify(data),
        };

        setHandleScan((state) => ({
          ...state,
          loading: true,
        }));
        return dispatch(ACTIONS.socketEmitEvent(dataObj));
      }
    },
    [address, dispatch, namespace]
  );

  const handleCheckExternalDevice = useCallback(
    (factorySerial, source, username, password, requestId) => {
      if (factorySerial && factorySerial.length > 0) {
        let data = {
          serial: factorySerial.trim(),
          namespace,
          deviceType: 'camera',
          extraInfo: {
            typeCamera: 'milestone',
            factorySerial,
            source,
            username,
            password
          },
          gatewaySerial,
        };
        console.log('🚀 ~ MilestoneCameraAddComponent ~ data:', data)
        let dataObj = {
          appServiceType: SERVICE.CHECK_EXTERNAL_DEVICE,
          requestId,
          body: JSON.stringify(data),
        };
        return dispatch(ACTIONS.socketEmitEvent(dataObj));
      }
    },
    [dispatch, namespace, gatewaySerial]
  );

  const onFinish = useCallback(
    (values) => {
      setStepsEnabled(false)
      setHandleScan((prev) => ({
        ...prev,
        loading: true,
        data: {
          ...prev.data,
          ...values
        }
      }));
      const dataTimeRequest = new Date().getTime();
      setRequestId(dataTimeRequest)
      if (handleScan.step === 0) {
        const { factorySerial, source, username, password } = values;
        handleCheckExternalDevice(factorySerial, source, username, password, dataTimeRequest)
      }
      if (handleScan.step === 1) {
        const { name } = values;
        handleAddDevice(handleScan.data?.factorySerial, name, dataTimeRequest)
      }

      if (handleScan.step === 2) {
        handleUpdateDevice({
          location: values.location ?? "",
          serial: handleScan.data.serial,
          tags: values.tags?.join(';')?.toLowerCase() || ';',
        }, dataTimeRequest)
      }

      setHandleTimer(15);
      refHandleTimer.current = setInterval(() => {
        setHandleTimer((timer) => timer - 1);
      }, 1000);
    },
    [handleScan.step, handleCheckExternalDevice]
  );

  useEffect(() => {
    if (!checkExternalDevice) return;
    if (checkExternalDevice?.requestId !== requestId) return
    setHandleScan(prev => ({
      ...prev,
      loading: false
    }))
    if (checkExternalDevice?.result === 1) {
      if (checkExternalDevice?.data && typeof checkExternalDevice?.data === 'string') {
        const data = JSON.parse(checkExternalDevice?.data)
        setHandleScan(prev => ({
          ...prev,
          step: 1,
          data: {
            ...prev.data,
            serial: data?.serial
          }
        }))
        dispatch(ACTIONS.checkExternalDeviceReturn(null));
      }
    } else {
      if (checkExternalDevice.result === -8) {
        form.setFields([
          {
            name: 'factorySerial',
            errors: [t('Device already exists')],
          },
        ])
        return
      }
      form.setFields([
        {
          name: 'password',
          errors: [t('Some thing went wrong')],
        },
      ])
    }
  }, [checkExternalDevice, requestId]);

  return (
    <div className="milestone-add-camera-component">
      <div className="steps-add-camera">
        <Steps size="small" current={handleScan?.step}>
          <Step title={t('Validate')} />
          <Step title={t('Create')} />
          <Step title={t('Update')} />
        </Steps>
      </div>
      <div className="add-camera-form">
        <div className="main-form">
          <Form
            form={form}
            {...layout}
            name="nest-messages"
            onFinish={onFinish}
            noValidate={true}
          >
            {
              handleScan.step === 0 && (
                <>
                  <Form.Item
                    name="factorySerial"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter factory serial'
                      },
                      {
                        len: 36,
                        message: t('Please input to 36 characters!'),
                      },
                    ]}
                    label={t('Factory serial')}
                  >
                    <Input placeholder='Enter factory serial' />
                  </Form.Item>
                  <Form.Item
                    name="source"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter source'
                      },
                      {
                        validator: (_, value) => {
                          if (!value || regex.isMilestoneSrc.test(value)) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Please enter a valid source in the format http(s)://IP:port'));
                        },
                      },
                    ]}
                    label={t('Source')}
                  >
                    <Input placeholder='http(s)://ip:port' type="text" />
                  </Form.Item>
                  <Form.Item
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter username'
                      },
                      {
                        pattern: regex.isName,
                        message: t('Please enter only letters and numbers!'),
                      },
                    ]}
                    label={t('Username')}
                  >
                    <Input placeholder='Enter username' />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter password'
                      },
                      {
                        pattern: regex.isText,
                        message: t('Please enter only letters and numbers!'),
                      },
                    ]}
                    label={t('Password')}
                  >
                    <Input type='password' placeholder='Enter password' />
                  </Form.Item>
                </>
              )
            }
            {
              handleScan.step === 1 && (
                <>
                  <Form.Item
                    initialValue={handleScan.data?.serial || ''}
                    name="serial"
                    label={t('Serial')}
                  >
                    <Input disabled />
                  </Form.Item>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        pattern: regex.isName,
                        message: t('Please enter only letters and numbers!'),
                      },
                      {
                        max: 80,
                        message: t('Please enter up to 80 characters!'),
                      },
                    ]}
                    label={t('Name')}
                  >
                    <Input placeholder='Enter camera name' />
                  </Form.Item>
                </>
              )
            }
            {
              handleScan.step === 2 && (
                <>
                  <Form.Item
                    name="location"
                    rules={[
                      {
                        pattern: regex.isName,
                        message: t('Please enter only letters and numbers!'),
                      },
                      {
                        max: 200,
                        message: t('Please enter up to 200 characters!'),
                      },
                    ]}
                    label={t('Location')}
                  >
                    <LocationSearchLocationIQ
                      address={address.note}
                      clearAddress={() => setAddress({ note: '' })}
                      onChange={handleAddressChange}
                      onAddressSelect={handleSelect}
                      setIsBlock={setIsBlock}
                    />
                  </Form.Item>
                  <Form.Item
                    name="tags"
                    className="tags-device"
                    label={t('Tag')}
                    style={{ borer: '1px solid #434343', borderRadius: '2px' }}
                  >
                    <InputTag numberTag={3} nameAdd="Add tag" />
                  </Form.Item>
                </>
              )
            }
            <div className="form-buttons">
              {
                handleScan.step === 0 && (
                  <div className="child-btn">
                    <Form.Item>
                      <Button
                        type="primary"
                        loading={handleScan.step === 0 && handleScan.loading}
                        htmlType="submit"
                      >
                        {t('Validate')}
                      </Button>
                    </Form.Item>
                  </div>
                )
              }
              {
                handleScan.step === 1 && (
                  <>
                    <div className="child-btn">
                      <Form.Item>
                        <Button onClick={handleBack}>
                          {t('Back')}
                        </Button>
                      </Form.Item>
                    </div>
                    <div className="child-btn">
                      <Form.Item>
                        <Button
                          type="primary"
                          loading={handleScan.step === 1 && handleScan.loading}
                          htmlType="submit"
                        >
                          {t('Create')}
                        </Button>
                      </Form.Item>
                    </div>
                  </>
                )
              }
              {
                handleScan.step === 2 && (
                  <>
                    <div className="child-btn">
                      <Form.Item>
                        <Button onClick={() => onDone()}>
                          {t('Skip')}
                        </Button>
                      </Form.Item>
                    </div>
                    <div className="child-btn">
                      <Form.Item>
                        <Button
                          type="primary"
                          loading={handleScan.step === 2 && handleScan.loading}
                          htmlType="submit"
                        >
                          {t('Update')}
                        </Button>
                      </Form.Item>
                    </div>
                  </>
                )
              }
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default MilestoneCameraAddComponent;
